import { render, staticRenderFns } from "./TtypeTables.vue?vue&type=template&id=a11a386c&scoped=true&"
import script from "./TtypeTables.vue?vue&type=script&lang=js&"
export * from "./TtypeTables.vue?vue&type=script&lang=js&"
import style0 from "./TtypeTables.vue?vue&type=style&index=0&id=a11a386c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11a386c",
  null
  
)

export default component.exports